/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var InfoSquareIcon64Regular = forwardRef('InfoSquareIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M34.003 20.752a2.252 2.252 0 1 1-4.503 0 2.252 2.252 0 0 1 4.503 0Z" }),
        React.createElement("path", { d: "M28.5 27a1.5 1.5 0 0 0 0 3H31v12h-4a1.5 1.5 0 0 0 0 3h11a1.5 1.5 0 0 0 0-3h-4V30a3 3 0 0 0-3-3h-2.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 17.5C7 11.701 11.701 7 17.5 7h29C52.299 7 57 11.701 57 17.5v29C57 52.299 52.299 57 46.5 57h-29C11.701 57 7 52.299 7 46.5v-29ZM17.5 10a7.5 7.5 0 0 0-7.5 7.5v29a7.5 7.5 0 0 0 7.5 7.5h29a7.5 7.5 0 0 0 7.5-7.5v-29a7.5 7.5 0 0 0-7.5-7.5h-29Z" })));
});
